// src/components/Programs.jsx

import { FaSwimmer, FaHeartbeat, FaChalkboardTeacher, FaSync } from "react-icons/fa";
import { Link } from "react-router-dom";

const programGroups = [
  {
    title: "Bronze & National Lifeguard",
    icon: <FaSwimmer className="text-blue-600 text-3xl" />,
    description: "Start your lifeguard journey with Bronze Star to National Lifeguard certification.",
    link: "/lifeguarding"
  },
  {
    title: "First Aid & CPR",
    icon: <FaHeartbeat className="text-red-600 text-3xl" />,
    description: "Master life-saving techniques with Emergency & Standard First Aid courses.",
    link: "/first-aid"
  },
  {
    title: "Instructor & Advanced Courses",
    icon: <FaChalkboardTeacher className="text-green-600 text-3xl" />,
    description: "Train to teach lifesaving, swim instruction, and advanced evaluations.",
    link: "/instructor"
  },
  {
    title: "Recertifications",
    icon: <FaSync className="text-yellow-600 text-3xl" />,
    description: "Renew your certifications quickly with our focused refresher sessions.",
    link: "/recertifications"
  }
];

const Programs = () => (
  <section id="Programs" className="py-20 px-4 bg-gray-100">
    <h2 className="text-4xl font-bold text-center text-gray-900 mb-12">Explore Our Training Programs</h2>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
      {programGroups.map((group) => (
        <div key={group.title} className="bg-white p-6 rounded-2xl shadow-md hover:shadow-lg transition">
          <div className="flex items-center gap-4 mb-4">
            {group.icon}
            <h3 className="text-xl font-bold text-gray-800">{group.title}</h3>
          </div>
          <p className="text-gray-700 mb-6">{group.description}</p>
          <Link to={group.link}>
            <button className="bg-blue-600 text-white px-5 py-2 rounded-md text-sm font-semibold hover:bg-blue-700 transition">
              See Courses
            </button>
          </Link>
        </div>
      ))}
    </div>
  </section>
);

export default Programs;
